import {baseUrl} from '@/utils/global'
export default {
  method: 'get',
  baseUrl: baseUrl,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  },
  data: {},
  timeout: 600000,
  //携带凭证
  withCredentials: true,
  responseType: 'json'
}



// WEBPACK FOOTER //
// ./src/http/config.js